import {useCallback, useEffect, useState} from "react";
import {useSnackbarContext} from "../../common/Snackbar";
import {findHubById, updateHubById} from "../../../api/HubApi";
import {findPipes, updatePipeById} from "../../../api/PipeApi";

export default function UseHubSettings({hubId}) {
    const [hub, setHub] = useState(undefined);
    const [pipes, setPipes] = useState(undefined);
    const [hubLoading, setHubLoading] = useState(true);
    const [pipesLoading, setPipesLoading] = useState(true);

    const {handleMessageUpdate} = useSnackbarContext();

    function handleApiError(error) {
        handleMessageUpdate(`${error.message} [${error.code}]`);
    }

    const handleErrorCallback = useCallback(handleApiError, []);

    useEffect(() => {
        function handleHubChanged(hub) {
            setHub(hub);
        }

        function handlePipesChanged(pipes) {
            setPipes(pipes);
        }

        function handleHubLoadingChanged(value) {
            setHubLoading(value);
        }

        function handlePipesLoadingChanged(value) {
            setPipesLoading(value);
        }

        findHubById(hubId)
            .then(hub => {
                handleHubChanged(hub);
                handleHubLoadingChanged(false);
                return findPipes(hubId);
            })
            .then(pipes => {
                handlePipesChanged(pipes);
                handlePipesLoadingChanged(false);
                return Promise.resolve();
            })
            .catch(error => {
                handleHubLoadingChanged(false);
                handlePipesLoadingChanged(false);
                handleErrorCallback(error);
            });
    }, [hubId, handleErrorCallback]);

    function handleHubTitleChanged(title) {
        setHub(Object.assign({}, hub, {title: title}));
    }

    function handlePipeTitleChanged(pipeId, title) {
        const newPipes = [...pipes];
        const [pipe] = newPipes.filter(pipe => pipe.id === pipeId);

        pipe.title = title;

        setPipes(newPipes);
    }

    function handlePipeStatusChanged(pipeId, status) {
        const newPipes = [...pipes];
        const [pipe] = newPipes.filter(pipe => pipe.id === pipeId);

        pipe.status = status;

        setPipes(newPipes);
    }

    function handlePipePeriodChanged(pipeId, period) {
        const newPipes = [...pipes];
        const [pipe] = newPipes.filter(pipe => pipe.id === pipeId);

        pipe.period = period;

        setPipes(newPipes);
    }

    function handleHubApplyClick() {
        return updateHubById(hubId, {
            title: hub.title
        }).catch(error => {
            handleApiError(error);
        });
    }

    function handlePipeApplyClick(pipeId) {
        const [pipe] = pipes.filter(pipe => pipe.id === pipeId);

        return updatePipeById(hubId, pipeId, {
            title: pipe.title,
            status: pipe.status,
            period: pipe.period,
            metadata: pipe.metadata
        }).catch(error => {
            handleApiError(error);
        });
    }

    return {
        hubLoading,
        pipesLoading,
        hub,
        pipes,
        handleHubTitleChanged,
        handlePipeTitleChanged,
        handlePipeStatusChanged,
        handlePipePeriodChanged,
        handleHubApplyClick,
        handlePipeApplyClick
    };
}